import { useRef, useState } from "react";
import { useInView } from "framer-motion";
import dayjs from "dayjs";
import "./HomeAbout.css";
import { FiDownload } from "react-icons/fi";
import { RxColorWheel } from "react-icons/rx";
import { useHomeContext } from "../../../context/Home_context";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "swiper/css";
import "swiper/css/navigation";
import noImg from "../../../Assets/No_img.jpg";

const HomeAbout = () => {
  const { current_expo_data } = useHomeContext();
  const [lightboxIndex, setLightboxIndex] = useState(-1);
  const sectionRef = useRef(null);
  const inView = useInView(sectionRef, { amount: 0.2, once: true });

  return (
    <section
      ref={sectionRef}
      className={`as-about ${inView ? "as-in-view" : ""}`}
      id="about"
    >
      <div className="as-wave as-wave--top" aria-hidden="true">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none">
          <path
            d="M0,28 C400,60 1040,0 1440,28 L1440,0 L0,0 Z"
            fill="var(--brand-pink)"
          />
        </svg>
      </div>

      {current_expo_data?.expo_heading &&
        current_expo_data?.from_date &&
        current_expo_data?.to_date &&
        dayjs().valueOf() >= dayjs(current_expo_data.from_date).startOf("day").valueOf() &&
        dayjs().valueOf() <= dayjs(current_expo_data.to_date).endOf("day").valueOf() && (
          <div className="as-ticker" role="status">
            <div className="as-ticker-row">
              <span className="as-ticker-dot" aria-hidden="true" />
              <span className="as-ticker-text">{current_expo_data.expo_heading}</span>
            </div>
            <span
              className="as-ticker-strip as-ticker-strip--bottom"
              aria-hidden="true"
            />
          </div>
        )}

      <div className="as-building-bg" aria-hidden="true" />

      <div className="as-container">
        {/* ---------- Slider column (Slides in from Left + tilted scale) ---------- */}
        <div
          className="as-media as-reveal-media"
          style={{ "--as-delay": "150ms" }}
        >
          <div className="as-media-frame">
            {current_expo_data?.welcome_images &&
            current_expo_data.welcome_images.length > 0 ? (
              <div className="custom-about-slider-wrapper">
                <Swiper
                  modules={[Autoplay, Navigation]}
                  slidesPerView={1}
                  spaceBetween={0}
                  loop={current_expo_data.welcome_images.length > 1}
                  speed={700}
                  autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  className="about-swiper"
                >
                  {current_expo_data.welcome_images.map((item, idx) => (
                    <SwiperSlide key={item?.id || idx}>
                      <img
                        src={item?.image_full_path || item?.image}
                        alt={`Bharat Buildcon Exhibition ${idx + 1}`}
                        className="intro-photo"
                        style={{ cursor: "pointer" }}
                        onClick={() => setLightboxIndex(idx)}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            ) : (
              <img
                src={noImg}
                alt="Bharat Buildcon About"
                className="intro-photo"
              />
            )}
            <span className="as-media-ribbon" aria-hidden="true" />
          </div>
        </div>

        {/* ---------- Content column ---------- */}
        <div className="as-content">
          <div className="as-card">
            {current_expo_data?.meta_keyword && (
              <span
                className="as-tag as-reveal-top-left"
                style={{ "--as-delay": "200ms" }}
              >
                <RxColorWheel className="as-tag-icon" />
                {current_expo_data.meta_keyword}
              </span>
            )}

            {current_expo_data?.meta_title && (
              <h2
                className="as-heading as-reveal-left"
                style={{ "--as-delay": "400ms" }}
              >
                {current_expo_data.meta_title}
              </h2>
            )}

            {current_expo_data?.meta_desc && (
              <p
                className="as-text as-reveal-left"
                style={{ "--as-delay": "650ms" }}
              >
                {current_expo_data.meta_desc}
              </p>
            )}

            {current_expo_data?.brochure_full_path && (
              <div className="as-cta-row">
                <a
                  href={current_expo_data.brochure_full_path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="as-btn as-btn--solid as-reveal-bottom"
                  style={{ "--as-delay": "1900ms" }}
                >
                  Download Brochure
                  <FiDownload size={16} />
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="as-wave as-wave--bottom" aria-hidden="true">
        <svg viewBox="0 0 1440 60" preserveAspectRatio="none">
          <path
            d="M0,28 C400,0 1040,60 1440,60 L1440,60 L0,60 Z"
            fill="var(--brand-purple)"
          />
        </svg>
      </div>

      {/* Lightbox Modal */}
      {current_expo_data?.welcome_images &&
        current_expo_data.welcome_images.length > 0 && (
          <Lightbox
            open={lightboxIndex >= 0}
            index={lightboxIndex}
            close={() => setLightboxIndex(-1)}
            slides={current_expo_data.welcome_images.map((item) => ({
              src: item?.image_full_path || item?.image,
            }))}
            plugins={[Zoom]}
            zoom={{
              maxZoomPixelRatio: 5,
              zoomInMultiplier: 2,
            }}
            animation={{ swipe: 280 }}
          />
        )}
    </section>
  );
};

export default HomeAbout;
